var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Abstract from "./abstract";
var MultiInput = /** @class */ (function (_super) {
    __extends(MultiInput, _super);
    function MultiInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiInput.prototype.getEditable = function () {
        var editable = this.Editables.get('multi_input');
        return editable ? editable : false;
    };
    MultiInput.prototype.map = function () {
        this.args.subtype = this.column.editable.subtype;
        return this.args;
    };
    return MultiInput;
}(Abstract));
export default MultiInput;
